var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeatured = function SvgFeatured(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 4,
    y: 4,
    fill: "#171717",
    rx: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 4,
    y: 4,
    stroke: "#E4E4E4",
    strokeWidth: 8,
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19 28c4.5 0 9-4.5 9-9 0 4.5 4.5 9 9 9-4.5 0-9 4.5-9 9 0-4.5-4.5-9-9-9ZM18 35.5c.833 0 2.5-1.667 2.5-2.5 0 .833 1.667 2.5 2.5 2.5-.833 0-2.5 1.667-2.5 2.5 0-.833-1.667-2.5-2.5-2.5ZM32 21c1 0 3-2 3-3 0 1 2 3 3 3-1 0-3 2-3 3 0-1-2-3-3-3Z"
  })));
};
export default SvgFeatured;